import React from 'react'
// import LowArrow from '../../../images/lowArrow.png'
// import HighArrow from '../../../images/highArrow.png'

export const CustomTableRow = (props) => {
  return (
    <div
      className="custom-table-row"
      id="highlow-table-row"
    >
      <p className="date">{props.date}</p>
      <p className="target">{props.protein}g</p>
      <p className="target">{props.carbs}g</p>
      <p className="target">{props.fat}g</p>
      <p className="target">{props.calories}</p>
    </div>
  );
};
